












































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { OperationItemType } from '../../types/type'
import { ElMessageComponent } from 'element-ui/types/message'
import { getAllFatherNodeForTree } from '../../utils/toolsForCommon'
import { CanteenModule, UserModule } from '../../store'
@Component({
  name: 'CanteenSubject',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class CanteenSubject extends Vue {
  public filterText = ''
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  public loadingForCanteenSubjectContent = false
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-circle-plus-outline m_r5'></span>新增科目",
      key: 'add',
      type: 'primary',
      size: ''
    }
  ]
  public dialogFlag = false
  public isOnlyLook = false
  // 0：表示贷；1：表示借。指该科目增加时的资金流向,必传
  public directionTypeOptions: any[] = [
    {
      label: '贷',
      value: false
    },
    {
      label: '借',
      value: true
    }
  ]
  public code = ''
  public name = ''
  public direction = ''
  public belongTo: string[] = []
  public title = ''
  public whoEditorId = ''
  // 科目单位表相关：
  public subjectUnitList: any[] = []
  public subjectUnitMap: Map<string, string> = new Map()
  public unitText: string = ''
  public unitForInput: string = ''
  public setForWho: any = null

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    return (this as any).$RoleCode
  }

  get thisPageRoleCodeObj () {
    return this.allRole['Subject']
  }

  @Watch('filterText') filterTextChange (val: any) {
    (this.$refs.tree as any).filter(val)
  }

  mounted (): void {
    this.disposeForOperationForButtonOfTableHeader()
    this.getTreeDataForDisposeNameSubject()
    this.getCanteenCommonQuerySubjectUnit()
  }

  // 通过权限判断头部按钮的展示与否：
  disposeForOperationForButtonOfTableHeader () {
    this.operationForButtonOfTableHeader = this.operationForButtonOfTableHeader.map(item => {
      const { key } = item
      switch (key) {
        case 'add':
          if (this.userInfoAuthority.includes(this.thisPageRoleCodeObj.Subject_Management_Add_Subject.code)) {
            item['hide'] = false
          } else {
            item['hide'] = true
          }
      }
      return item
    })
  }

  operationForButton ({ key }, row) {
    switch (key) {
      case 'add':
        this.dialogFlag = true
        this.title = '新增科目'
        this.code = this.name = this.direction = this.whoEditorId = ''
        this.belongTo = []
        break
    }
  }

  editorNode (data) {
    this.dialogFlag = true
    this.title = '编辑科目'
    this.code = data.code
    this.name = data.orginName
    this.direction = data.direction
    this.whoEditorId = data.code
    this.belongTo = getAllFatherNodeForTree(this.treeDataForDisposeNameSubject, 'children', 'code', data.pcode)
  }

  async save () {
    try {
      // if (!this.code) return this.$message.error('请输入科目编码')
      if (!this.name) return this.$message.error('请输入科目名称')
      if (this.direction === '') return this.$message.error('请选择借贷方向')
      if (!this.belongTo.length) return this.$message.error('请选择所属科目')
      let params = {
        // code: this.code,
        name: this.name,
        direction: this.direction,
        pcode: this.belongTo[this.belongTo.length - 1]
      }
      let message = '科目新增成功'
      let api = 'subjectAdd'
      if (this.whoEditorId) {
        message = '科目编辑成功'
        api = 'subjectUpdate'
        Object.assign(params, { code: this.whoEditorId })
      }
      const { data: result } = await (this as any).$http[api](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(message)
      this.dialogFlag = false
      this.code = this.name = this.direction = this.whoEditorId = ''
      this.belongTo = []
      this.getTreeDataForDisposeNameSubject()
      this.hideMask()
    } catch (err) {
      console.log(err)
    }
  }

  hideMask () {
    this.dialogFlag = false
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  async getTreeDataForDisposeNameSubject (): Promise<ElMessageComponent | void> {
    try {
      this.loadingForCanteenSubjectContent = true
      await CanteenModule.getTreeDataForDisposeNameSubject()
      this.loadingForCanteenSubjectContent = false
    } catch (err) {
      console.log(err)
    }
  }

  async getCanteenCommonQuerySubjectUnit () {
    try {
      const { data: result } = await (this as any).$http.canteenCommonQuerySubjectUnit()
      if (result.code !== 200) return this.$message.error(result.msg)
      this.subjectUnitList = result.data
      this.subjectUnitList.forEach(item => {
        let { subject, unit } = item
        this.subjectUnitMap.set(subject, unit)
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForLookUnitOfNode (data) {
    let unit = '- -'
    if (this.subjectUnitMap.has(data.code)) {
      unit = this.subjectUnitMap.get(data.code)
    }
    this.unitText = unit
  }

  operationForSetUnitOfNode (data) {
    this.setForWho = data
    this.unitForInput = ''
  }

  async confirmForSetUnitOfNode () {
    try {
      if (!this.unitForInput) return this.$message.warning('请输入单位')
      const { code } = this.setForWho
      const params = {
        subject: code,
        unit: this.unitForInput
      }
      const { data: result } = await (this as any).$http.subjectUnitSave(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('单位设置成功')
      this.getTreeDataForDisposeNameSubject()
      this.getCanteenCommonQuerySubjectUnit()
    } catch (err) {
      console.log(err)
    }
  }
}
